import { render, staticRenderFns } from "./GoodsBrandEdit.vue?vue&type=template&id=085297e2&"
import script from "./GoodsBrandEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsBrandEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports